export const filterByQuery = <T extends Record<string, unknown>>(events: T[], search: string) => {
  const query = search.trim();
  if (query === '') {
    return events;
  }
  const searchText = query.replace(/: /g, ':');
  return events.filter((event: T) =>
    JSON.stringify(event).toLowerCase().includes(searchText.toLowerCase()),
  );
};

export const formatTime = (time: number) => {
  const minutesDivisor = time % (60 * 60);
  const minutes = Math.floor(minutesDivisor / 60);
  const secondsDivisor = minutesDivisor % 60;
  const seconds = Math.ceil(secondsDivisor);
  const formattedMinutes = `0${minutes}`.slice(-2);
  const formattedSeconds = `0${seconds}`.slice(-2);
  return `${formattedMinutes}:${formattedSeconds}`;
};
